(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("fs"));
	else if(typeof define === 'function' && define.amd)
		define("PDFFormFiller", ["fs"], factory);
	else if(typeof exports === 'object')
		exports["PDFFormFiller"] = factory(require("fs"));
	else
		root["PDFFormFiller"] = factory(root["fs"]);
})(this, (__WEBPACK_EXTERNAL_MODULE_fs__) => {
return 